/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_FailedInputs */

const en_mobile_scan_failed = /** @type {(inputs: Mobile_Scan_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan failed`)
};

const es_mobile_scan_failed = /** @type {(inputs: Mobile_Scan_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo escanear`)
};

/**
* | output |
* | --- |
* | "Scan failed" |
*
* @param {Mobile_Scan_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_failed = /** @type {((inputs?: Mobile_Scan_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_failed(inputs)
	return en_mobile_scan_failed(inputs)
});